export enum SUMMERTIME_EVENT_ACTIONS_TYPES {
  ACTION_REQUEST_EVENT_DATA = 'app/event-summertime/ACTION_REQUEST_EVENT_DATA',
  ACTION_RESPONSE_EVENT_DATA = 'app/event-summertime/ACTION_RESPONSE_EVENT_DATA',
  ACTION_RESPONSE_MOTIVATOR_EVENT = 'app/event-summertime/ACTION_RESPONSE_MOTIVATOR_EVENT',
  ACTION_REQUEST_MOTIVATOR_DATA = 'app/event-summertime/ACTION_REQUEST_MOTIVATOR_DATA',
  ACTION_RESPONSE_MOTIVATOR_DATA = 'app/event-summertime/ACTION_RESPONSE_MOTIVATOR_DATA',
  ACTION_EVENT_DATA_FROM_SOCKET_EVENT = 'app/event-summertime/ACTION_EVENT_DATA_FROM_SOCKET_EVENT',
  ACTION_PICK_UP_PRIZE = 'app/event-summertime/ACTION_PICK_UP_PRIZE',
  ACTION_RESPONSE_PICK_UP_PRIZE = 'app/event-summertime/ACTION_RESPONSE_PICK_UP_PRIZE',
  ACTION_PICK_UP_PRIZE_OPENED = 'app/event-summertime/ACTION_PICK_UP_PRIZE_OPENED',
  ACTION_REQUEST_CATEGORY = 'app/event-summertime/ACTION_REQUEST_CATEGORY',
  ACTION_RESPONSE_CATEGORY = 'app/event-summertime/ACTION_RESPONSE_CATEGORY',
  ACTION_RESPONSE_CASE_RARE_INFO = 'app/event-summertime/ACTION_RESPONSE_CASE_RARE_INFO',
  ACTION_CLEAR_RARE_CASE_INFO = 'app/event-summertime/ACTION_CLEAR_RARE_CASE_INFO',
  //NOTE: Leader race types
  ACTION_RESPONSE_LR_BALANCE = 'app/event-summertime/ACTION_RESPONSE_LR_BALANCE',
  ACTION_REQUEST_LR_BALANCE = 'app/event-summertime/ACTION_REQUEST_LR_BALANCE',
  ACTION_REQUEST_LR_QUESTS = 'app/event-summertime/ACTION_REQUEST_LR_QUESTS',
  ACTION_RESPONSE_LR_QUESTS = 'app/event-summertime/ACTION_RESPONSE_LR_QUESTS',
  EVENT_ACTION_LR_QUEST = 'app/event-summertime/EVENT_ACTION_LR_QUEST',
  ACTION_TAKE_REWARD = 'app/event-summertime/ACTION_TAKE_REWARD',
  ACTION_REQUEST_LR_BALANCE_LOADING = 'app/event-summertime/ACTION_REQUEST_LR_BALANCE_LOADING',
  ACTION_REQUEST_LR_QUESTS_LOADING = 'app/event-summertime/ACTION_REQUEST_LR_QUESTS_LOADING',
  ACTION_REQUEST_LR_CASES = 'app/event-summertime/ACTION_REQUEST_LR_CASES',
  ACTION_RESPONSE_LR_CASES = 'app/event-summertime/ACTION_RESPONSE_LR_CASES',
  ACTION_REQUEST_LR_DATA = 'app/event-summertime/ACTION_REQUEST_LR_DATA',
  ACTION_RESPONSE_LR_DATA = 'app/event-summertime/ACTION_RESPONSE_LR_DATA',
}
